var _g, _g2, _g3, _g4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "medicalGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0ea5e9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#06b6d4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crossGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dc2626",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a8a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "pulseGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 0
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "url(#pulseGradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "20;25;20",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.1;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 18,
    fill: "white",
    stroke: "url(#medicalGradient)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "2;3;2",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 20,
    height: 6,
    rx: 3,
    fill: "url(#crossGradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "20;22;20",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 6,
    height: 20,
    rx: 3,
    fill: "url(#crossGradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "20;22;20",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L8 0 L10 -8 L12 16 L14 -12 L16 8 L18 0 L25 0",
    stroke: "url(#crossGradient)",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translateX",
    values: "0;5;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4,
    fill: "none",
    stroke: "url(#medicalGradient)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;5;4",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2,
    fill: "url(#medicalGradient)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19 Q20 25 25 30 Q30 35 35 30 Q40 25 45 30",
    stroke: "url(#medicalGradient)",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;1;0.7",
    dur: "2.5s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 35)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, /*#__PURE__*/React.createElement("tspan", null, "S"), /*#__PURE__*/React.createElement("tspan", {
    opacity: 0
  }, "h\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.1s",
    begin: "0.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("tspan", {
    opacity: 0
  }, "u\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.1s",
    begin: "0.7s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("tspan", {
    opacity: 0
  }, "k\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.1s",
    begin: "0.9s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("tspan", {
    opacity: 0
  }, "l\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.1s",
    begin: "1.1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("tspan", {
    opacity: 0
  }, "a\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.1s",
    begin: "1.3s",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 35,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 600,
    fill: "url(#medicalGradient)"
  }, "\n      Medical\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1",
    dur: "0.5s",
    begin: "1.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translateX",
    values: "-30;0",
    dur: "0.5s",
    begin: "1.5s",
    fill: "freeze"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "#06b6d4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 280 30;360 280 30",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 27,
    width: 8,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 Q5 -5 10 0 Q15 5 20 0",
    stroke: "#0ea5e9",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;1;0.6",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 8 Q5 3 10 8 Q15 13 20 8",
    stroke: "#06b6d4",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.6;1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 20,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "#0891b2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 4,
    height: 6,
    fill: "#0891b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 8,
    height: 2,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 2,
    height: 8,
    fill: "#ef4444"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 45,
    x2: 120,
    y2: 45,
    stroke: "url(#medicalGradient)",
    strokeWidth: 2,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.8",
    dur: "0.3s",
    begin: "1.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    values: "0;2",
    dur: "0.3s",
    begin: "1.8s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner3);
export default __webpack_public_path__ + "static/media/Partner3.bfd703c323aac05d907aedaed6b17135.svg";
export { ForwardRef as ReactComponent };